import memoizeOne from 'memoize-one';
import { getAuthor } from 'z3k-parser/model/author';
export function object2id(object) {
    return object.id;
}
/**
 * @function
 * @return функция, которая вернёт IDs
 * Из конфига получаем все ID нужных типов
 * @param object_namespace
 */
export function idExtractor(object_namespace) {
    return memoizeOne((config) => objects2ids(object_namespace.flatMap((objType) => objType.get.all(config))));
}
export function idIn(ids) {
    return (obj) => ids.includes(obj.id);
}
export function objects2ids(objects) {
    return objects.map((obj) => obj.id);
}
export function seemsLikeObjectId(num) {
    return typeof num == 'number' && getAuthor(num) > 0;
}
